/** The three products, keyed the way the backend's ProductTypeSchema is:
 *  cop_lop = lift, m8 = stair light, avira = ceiling light (2026-09-17 —
 *  Avira used to be folded into m8 here, so the Avira list showed lifts). */
export type ProductType = 'cop_lop' | 'm8' | 'avira' | 'unknown';

const COP_LOP_PREFIXES = ['HLC-', 'HCOPLOP-', 'LIFT-', 'COP-', 'COPLOP-'];
const AVIRA_PREFIXES   = ['HCL-', 'HCEILING-', 'CEIL-'];
const M8_PREFIXES      = ['HM8-', 'STAIR-', 'M8-'];

export function inferProductType(serial: string): ProductType {
  if (!serial) return 'unknown';
  const s = serial.toUpperCase();
  if (COP_LOP_PREFIXES.some((p) => s.startsWith(p))) return 'cop_lop';
  if (AVIRA_PREFIXES.some((p) => s.startsWith(p)))   return 'avira';
  if (M8_PREFIXES.some((p) => s.startsWith(p)))      return 'm8';
  return 'unknown';
}

export function productLabel(t: ProductType): string {
  switch (t) {
    case 'cop_lop': return 'COP-LOP';
    case 'm8':      return 'M8 Light';
    case 'avira':   return 'Avira';
    default:        return '—';
  }
}

export function productBadgeClass(t: ProductType): string {
  switch (t) {
    case 'cop_lop': return 'bg-indigo-50 text-indigo-700 ring-indigo-200/60';
    case 'm8':      return 'bg-teal-50 text-teal-700 ring-teal-200/60';
    case 'avira':   return 'bg-amber-50 text-amber-700 ring-amber-200/60';
    default:        return 'bg-slate-100 text-slate-500 ring-slate-200/60';
  }
}
